import { Alert } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../hooks';
export const renderShiftDurationInfo = ({ startTime, duration, isEditingPastShift }) => {
    if (!startTime || !duration) {
        return null;
    }
    return React.createElement(ShiftDurationInfo, { startTime: startTime, duration: duration, isEditingPastShift: isEditingPastShift });
};
const ShiftDurationInfo = ({ startTime, duration, isEditingPastShift }) => {
    const { t } = useMissionsTranslation();
    const startDay = new Date(startTime).getDay();
    const endDateTime = new Date(startTime + duration);
    const endDay = endDateTime.getDay();
    const endDate = t('date', { value: endDateTime });
    const endTime = t('time', { value: endDateTime });
    let message = '';
    if (isEditingPastShift) {
        message = t('shifts.shiftEnded', { endDate, endTime });
    }
    else {
        if (startDay === endDay) {
            message = t('shifts.shiftEnd', { endTime });
        }
        else {
            message = t('shifts.shiftEndNextDay', { endDate, endTime });
        }
    }
    return (React.createElement(Alert, { severity: 'info', "data-test": 'shift-duration-info' }, message));
};
